import React, { useState } from "react";
import { api, formatApiError } from "../lib/api";
import { toast } from "sonner";
import { Wrench, Loader2 } from "lucide-react";

/**
 * Admin one-shot tool: scans confirmed 0-0 auto-draws and corrects any
 * that should have been 3-0 chat-silence forfeits. Always runs a dry-run
 * first so the admin sees the count before applying.
 */
export default function BackfillChatForfeitsButton() {
  const [busy, setBusy] = useState(false);
  const [preview, setPreview] = useState(null);

  const runDry = async () => {
    setBusy(true);
    try {
      const { data } = await api.post("/admin/backfill-chat-forfeits?dry_run=true");
      setPreview(data);
      if (data.fixed === 0) {
        toast.success("No 0-0 auto-draws need correction. ✅");
      } else {
        toast(`Found ${data.fixed} match(es) to correct. Press 'Apply' to fix.`);
      }
    } catch (e) {
      toast.error(formatApiError(e));
    } finally {
      setBusy(false);
    }
  };

  const apply = async () => {
    setBusy(true);
    try {
      const { data } = await api.post("/admin/backfill-chat-forfeits");
      toast.success(`Corrected ${data.fixed} match(es). ${data.affected_user_count} player(s) updated.`);
      setPreview(null);
    } catch (e) {
      toast.error(formatApiError(e));
    } finally {
      setBusy(false);
    }
  };

  return (
    <div className="flex items-center gap-2 flex-wrap" data-testid="backfill-chat-forfeits">
      <button
        type="button"
        onClick={runDry}
        disabled={busy}
        data-testid="backfill-chat-forfeits-scan"
        className="inline-flex items-center gap-2 border border-[#7C3AED] text-[#7C3AED] font-mono text-[10px] uppercase tracking-[0.25em] px-3 py-2 hover:bg-[#7C3AED] hover:text-white transition-colors disabled:opacity-40"
      >
        {busy ? <Loader2 className="w-3 h-3 animate-spin" /> : <Wrench className="w-3 h-3" />}
        SCAN 0-0 DRAWS
      </button>
      {preview && preview.fixed > 0 && (
        <>
          <span className="font-mono text-[10px] uppercase tracking-[0.25em] text-[#71717A]">
            {preview.fixed} match{preview.fixed === 1 ? "" : "es"} to correct
          </span>
          <button
            type="button"
            onClick={apply}
            disabled={busy}
            data-testid="backfill-chat-forfeits-apply"
            className="inline-flex items-center gap-2 bg-[#00FF87] text-black font-mono text-[10px] uppercase tracking-[0.25em] px-3 py-2 hover:bg-[#5EF0B1] transition-colors disabled:opacity-40"
          >
            APPLY FIX
          </button>
        </>
      )}
    </div>
  );
}
